// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__SWgP2","intro_team":"intro_intro_team__mRFgf","intro_services":"intro_intro_services__4OVT9","intro__icon":"intro_intro__icon__rZm3X"};